module.exports = __webpack_public_path__ + "img/Company Users.5dea2097.svg";